import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
// import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import hist from 'middlewares/history';
import { registerAjaxAddAuthorizationHeader, registerAjaxNotAuthorizedRedirect } from './middlewares/axios';


import indexRoutes from "routes/index.jsx";
import ErrorBoundary from "./components/Article/common/error_boundary";

import "assets/scss/material-kit-pro-react.css?v=1.1.0";
import "assets/scss/custom-styles.css";

import configureStore from './configureStore';
import AutoReload from "./components/Autoreload/Autoreload";
import { BASE } from './config';

// import registerServiceWorker from './registerServiceWorker';

//Register middleware for axios which adds jwt session token to any ajax calls being made
registerAjaxAddAuthorizationHeader();

//Register middleware for axios which handles redirect when user authenticated session times out
registerAjaxNotAuthorizedRedirect();

const rootElement = <Provider store={configureStore()}>

    <Router history={hist}>
        <ErrorBoundary>
            <AutoReload url={BASE} tryDelay={5 * 60 * 1000} />
            <Switch>
                { indexRoutes.map((prop, key) => <Route exact path={prop.path} key={key} component={prop.component} /> ) }
            </Switch>
        </ErrorBoundary>
    </Router>
</Provider>;

ReactDOM.render(rootElement, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js